module.exports = __webpack_public_path__ + "img/download@2x.e74230be.jpg";